import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { v4 as uuidv4 } from 'uuid';
import { logger } from './log';
import { useBusinessStore } from './store';
import { SALE_LOG_EVENT, TERMINAL_TYPE, type TerminalType } from './types';

dayjs.extend(utc);

export function generateOrderNumber() {
    const businessInfo = useBusinessStore.getState().businessInfo;
    const registerIndex = businessInfo.registerIndex ?? 0;

    const timeStamp = dayjs.utc().format('YYMMDDHHmmss');
    const orderNumber = `${registerIndex}-${timeStamp}`;

    logger.info({
        eventName: SALE_LOG_EVENT,
        message: `[order-number] generated ${JSON.stringify({
            orderNumber,
            branchId: businessInfo.branchId,
            registerIndex,
        })}`,
    });

    return orderNumber;
}

export function generateRandomId() {
    return uuidv4();
}

export function generateMerchantReference(
    type: TerminalType = TERMINAL_TYPE.USB,
) {
    const businessInfo = useBusinessStore.getState().businessInfo;

    const registerIndex = businessInfo.registerIndex ?? 0;
    const branchId = businessInfo.branchId ?? '';

    return `MBK_${type}_${branchId}_${registerIndex}_${Date.now()}`;
}
